export default __webpack_public_path__ + "static/media/Photo 10 - MR - Plan 2.2ddde12a.png";